import {
    Module, VuexModule, Mutation, Action, getModule,
} from 'vuex-module-decorators';
import fileDownload from 'js-file-download';
import store from '@/state/store';
import { transactionsModuleAPI } from '@samclick-static-urls';
import { sendGet, sendPut, sendPost } from '@samclick-api-client';
import Payload from './payload';


class TransactionsModuleState {
    public loading: boolean = false

    public transactions: object[] = []
}

@Module({
    namespaced: true,
    dynamic: true,
    store,
    name: 'transactionsmodule',
})
class TransactionsModuleStore extends VuexModule {
    transactionsModuleStore: TransactionsModuleState = new TransactionsModuleState();

    @Mutation
    TRANSACTIONS_MODULE_REINITIALIZE() {
        this.transactionsModuleStore = new TransactionsModuleState();
    }

    @Mutation
    SET_TRANSACTIONS_MODULE_LOADING(loading: boolean) {
        this.transactionsModuleStore.loading = loading;
    }

   @Mutation
    SET_TRANSACTION_MODULE_SEARCH(response: object[] = []) {
        this.transactionsModuleStore.transactions = response || [];
    }

    @Action({ rawError: true })
   showLoader(show: boolean) {
       this.context.commit('SET_TRANSACTIONS_MODULE_LOADING', show);
   }

    @Action({ rawError: true })
    destroyTransactions() {
        this.context.commit('TRANSACTIONS_MODULE_REINITIALIZE');
    }

  @Action({ rawError: true })
    getAffTransactions(payload: Payload) {
        this.showLoader(payload.activateLoader);
        return new Promise((resolve, reject) => {
            sendGet(transactionsModuleAPI.getTransactions, payload.data, true).then((response) => {
                if (payload.storeData) {
                    this.context.commit('SET_TRANSACTION_MODULE_SEARCH', response.data);
                }
                this.showLoader(false);
                resolve(response);
            }, (error) => {
                this.showLoader(false);
                reject(error.response);
            });
        });
    }

  @Action({ rawError: true })
  exportAffiliateTransaction(payload: Payload = new Payload()) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendGet(transactionsModuleAPI.exportTransactions, payload.data, true).then((response) => {
              fileDownload(response.data, 'report-file.csv');
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }
}


export default getModule(TransactionsModuleStore);
